module.exports = __webpack_public_path__ + "static/media/guard.94a132ff.svg";